// extracted by mini-css-extract-plugin
export default {"container":"ExhibitorTradeFairAwards_container__oRXDI","titleLabel":"ExhibitorTradeFairAwards_titleLabel__8+556"};